import * as React from 'react';

import Button from '../../Button';
import {ProductLine} from '../../../infrastructure/interfaces';
import {CoverDocumentType} from '../../../infrastructure/CoverImageTypes';
import {DropdownMenu} from '../../DropdownMenu';
import {Modal} from '../../Modal';
import {ImageFileTypes} from '../../../infrastructure/ImageFileTypes'
import './CoverCreatorModal.css';
import {IDropdownMenuOption} from "../../DropdownMenu/DropdownMenu";

export interface CoverCreatorProps {
  show: any;
  onClose: any;
  onSubmit(coverImageName: string, coverImageType: ProductLine, coverDocumentType: CoverDocumentType, formData: FormData): void;
}

export interface CoverCreatorState {  
  coverImageName: string;
  coverImageType?: ProductLine;
  coverDocumentType?: CoverDocumentType;
  imageFormData: FormData;
  hasRequiredFields: boolean;
}

export default class CoverCreatorModal extends React.Component<CoverCreatorProps, CoverCreatorState> {

  constructor(props: CoverCreatorProps) {
    super(props);
    this.state = {
      coverImageName: "",
      coverImageType: undefined,
      coverDocumentType: undefined,
      imageFormData: new FormData(),
      hasRequiredFields: false
    };
  }

  closeModal() {
      this.setState({
      });
      this.props.onClose();
  }

  checkForValidInput() {
    this.setState({
      hasRequiredFields: this.state.coverImageName.length > 0
        && (this.state.coverImageType != undefined)
        && (this.state.coverDocumentType != undefined)
        && this.state.imageFormData.get(ImageFileTypes.COVER_THUMBNAIL) != null
        && this.state.imageFormData.get(ImageFileTypes.COVER_FRONT) != null
        && this.state.imageFormData.get(ImageFileTypes.COVER_BACK) != null
        && this.state.imageFormData.get(ImageFileTypes.COVER_PRINT) != null
    });
  }

  handleNameChange(text: string) {
    this.setState({
      coverImageName: text
    }, () => this.checkForValidInput());
  }

  handleProductLineChange(text: string) {
      this.setState({
          coverImageType: (text == "Loveland") ? ProductLine.LOVELAND : ProductLine.SEED
      }, () => this.checkForValidInput());
  }

  handleCoverDocumentTypeChange(text: string) {
      let coverType: CoverDocumentType = CoverDocumentType.CATALOGS_AND_BROCHURES
      switch(text) {
          case "Catalogs":
              coverType = CoverDocumentType.CATALOGS;
              break;
          case "Brochures":
              coverType = CoverDocumentType.BROCHURES;
              break;
          default:
              break;
      }
      this.setState({
          coverDocumentType: coverType
      }, () => this.checkForValidInput());
  }

  handleImageChange(imageId: string, selectorFiles: FileList | null)
  {
    if (selectorFiles != null) {
      for (var key in selectorFiles) {
        if (selectorFiles.hasOwnProperty(key) && selectorFiles[key] instanceof File) {
          var imageFormData = this.state.imageFormData
          imageFormData.set(imageId, selectorFiles[key]);
          this.setState({
            imageFormData
          }, () => this.checkForValidInput());
          break;
        }
      }
    }
  }

  render() {
      let coverTypeNameLookup = new Array();
      coverTypeNameLookup[ProductLine.LOVELAND] = "Loveland";
      coverTypeNameLookup[ProductLine.SEED] = "Dyna-Gro/Proven";
      const coverTypes: string[] = ["Loveland", "Dyna-Gro/Proven"];
      const coverTypeOptionsList: IDropdownMenuOption[] = coverTypes.map((type) => (
          {
              title: type,
              onClick: () => {
                  this.handleProductLineChange(type);
              }
          })
      );

      let coverDocumentTypeNameLookup = new Array();
      coverDocumentTypeNameLookup[CoverDocumentType.CATALOGS_AND_BROCHURES] = "Catalogs and Quad Folds";
      coverDocumentTypeNameLookup[CoverDocumentType.CATALOGS] = "Catalogs";
      coverDocumentTypeNameLookup[CoverDocumentType.BROCHURES] = "Quad Folds";
      const coverDocumentTypes: string[] = ["Catalogs and Quad Folds", "Catalogs", "Quad Folds"];
      const coverDocumentTypeOptionsList: IDropdownMenuOption[] = coverDocumentTypes.map((type) => (
          {
              title: type,
              onClick: () => {
                  this.handleCoverDocumentTypeChange(type);
              }
          })
      );
    return (
        <Modal show={this.props.show}
          onClose={() => {this.closeModal();}}
        >
            <Modal.Header>
                <div className="coverModalHeaderContainer">
                  <div>
                    <Modal.Title>
                        <h5>
                            {'Upload Cover Images'}
                        </h5>
                    </Modal.Title>
                    <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>
                  </div>
                  <div>
                      All Images Must be JPGs
                  </div>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className="coverInputContainer">
                    <label>
                        Cover Image Name (ex: "Wheat 2")
                    </label>
                  <input
                    className="coverModelInput"
                    type="text"
                    value={this.state.coverImageName}
                    onChange={(event) => this.handleNameChange(event.target.value)}
                  />
                </div>
                <div className="coverInputContainer">
                    <div>
                        <label>
                            Cover Sheet Type:
                        </label>
                    </div>
                    <div className="coverModelInput">
                        <DropdownMenu
                            title={(this.state.coverImageType != undefined) ? coverTypes[this.state.coverImageType] : ""}
                            options={coverTypeOptionsList}
                            extraWide={false}
                        />
                    </div>
                </div>
                <div className="coverInputContainer">
                    <div>
                        <label>
                            Cover Document Type:
                        </label>
                    </div>
                    <div className="coverModelInput">
                        <DropdownMenu
                            title={(this.state.coverDocumentType != undefined) ? coverDocumentTypes[this.state.coverDocumentType] : ""}
                            options={coverDocumentTypeOptionsList}
                            extraWide={false}
                        />
                    </div>
                </div>
                <div className="coverInputContainer">
                    <label>
                        Web Full Cover (17"x11", 1152x720 pixels, ~150KB)
                    </label>
                    <input type="file" className="filepond" onChange={(e) => this.handleImageChange(ImageFileTypes.COVER_THUMBNAIL, e.target.files)} />
                </div>
                <div className="coverInputContainer">
                    <label>
                        Front Cover (8.5"x11". 576x720 pixels)
                    </label>
                    <input type="file" className="filepond" onChange={(e) => this.handleImageChange(ImageFileTypes.COVER_FRONT, e.target.files)} />
                </div>
                <div className="coverInputContainer">
                    <label>
                        Back Cover (8.5"x11". 576x720 pixels)
                    </label>
                    <input type="file" className="filepond" onChange={(e) => this.handleImageChange(ImageFileTypes.COVER_BACK, e.target.files)} />
                </div>
                <div className="coverInputContainer">
                    <label>
                        Print Full Cover (17"x11", 4875x3075 pixels, 300x300 resolution)
                    </label>
                    <input type="file" className="filepond" onChange={(e) => this.handleImageChange(ImageFileTypes.COVER_PRINT, e.target.files)} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
                    Cancel
                </Button>
                <Button
                    bsClass="primary"
                    disabled={!this.state.hasRequiredFields}
                    onClick={() => {
                        if ((this.state.coverImageType != undefined) && (this.state.coverDocumentType != undefined)) {
                            this.props.onSubmit(this.state.coverImageName, this.state.coverImageType, this.state.coverDocumentType, this.state.imageFormData);
                            this.setState({
                                coverImageName: "",
                                coverImageType: undefined,
                                imageFormData: new FormData(),
                                hasRequiredFields: false
                                },);
                            }
                        }
                    }
                >
                    Upload
                </Button>
            </Modal.Footer>
        </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/CoverCreatorModal/CoverCreatorModal.tsx